import { gql } from "@apollo/client";

const GET_LEVELS = gql`
  query GetLevels {
    levels {
      id
      title
    }
  }
`;

export default GET_LEVELS;
